import React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import configureStore, { history } from "./store";
import { setGlobal } from "utils/globalState";

import { missionId } from "utils/urls";
import setFeatureFlags from "utils/featureFlags";

import Routes from "./Routes";
import { reportError } from "@jsainsburyplc/id-ui-common";

export const store = configureStore(/* provide initial state if any */);

const setGlobalMissionMetadata = () => {
  try {
    const missionMetadata = sessionStorage.getItem(missionId);
    setGlobal(JSON.parse(missionMetadata));
  } catch (e) {
    reportError(`App - error occurred during setGlobal mission metadata: ${e}`);
  }
};

setGlobalMissionMetadata();
setFeatureFlags();

const App = () => {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Routes />
      </ConnectedRouter>
    </Provider>
  );
};

export default App;
